import { graphql } from '../gql';
import { useQuery } from '@apollo/client';

export const GET_QUOTE_ENTITY = graphql(`
  query getQuote($uuid: String!) {
    quote(uuid: $uuid) {
      uuid
      createdAt
      updatedAt
      referenceId
      type
      name
      order
      ratedPremium
      quotedPremium
      limit
      retention
      minimumPremium
      technicalPremium
      isObsolete
      obsoleteAt
      endorsementImpact
      stcSelectedModifier
      stcMinModifier
      stcMaxModifier
      stcModifier
      stcRatedModifier
      erMinFusionScoreModifier
      erMaxFusionScoreModifier
      erRatedFusionScoreModifier
      erSelectedFusionScoreModifier
      erFusionScoreModifier
      srPercentage
      srModifier
      modifiedCoveragePremium
      status
    }
  }
`);

export function useQuoteQuery(uuid: string) {
  const { loading, error, data } = useQuery(GET_QUOTE_ENTITY, {
    variables: {
      uuid: uuid,
    },
    fetchPolicy: 'no-cache',
  });

  return {
    error,
    loading,
    data,
  };
}
